import { useGetUsage } from "./use-subscription";

type UsageMetricKey =
  // Credits-based checks
  // | "credits_emailHealth"
  // | "credits_inboxPlacement"
  // | "credits_senderProfile"

  // Limit-based checks
  | "limit_healthTestsUsedThisMonth"
  | "limit_inboxPlacementTestsUsedThisMonth"
  | "limit_senderProfilesUsed"
  | "limit_warmupEmailsSentToday"
  | "limit_warmupEmailsSentThisMonth";

export const useUsageLimitChecker = () => {
  const { data: usageData } = useGetUsage();

  const isUsageLimitReached = (metricKey: UsageMetricKey): boolean => {
    if (!usageData) {
      return true;
    }

    switch (metricKey) {
      // Credits-based checks
      // case "credits_emailHealth":
      //   return usageData.healthTestsUsedThisMonth >= usageData.maxHealthTestsUsedThisMonth;

      // case "credits_inboxPlacement":
      //   return usageData.inboxPlacementCredits === 0;

      // case "credits_senderProfile":
      //   return usageData.senderProfileCredits === 0;

      // Limit-based checks
      case "limit_healthTestsUsedThisMonth":
        return (
          usageData.healthTestsUsedThisMonth >=
          usageData.maxHealthTestsUsedThisMonth
        );

      case "limit_inboxPlacementTestsUsedThisMonth":
        return (
          usageData.inboxPlacementTestsUsedThisMonth >=
          usageData.maxInboxPlacementTestsUsedThisMonth
        );

      case "limit_senderProfilesUsed":
        return usageData.senderProfilesUsed >= usageData.maxSenderProfilesUsed;

      case "limit_warmupEmailsSentToday":
        return (
          usageData.warmupEmailsSentToday >= usageData.maxWarmupEmailsSentToday
        );

      case "limit_warmupEmailsSentThisMonth":
        return (
          usageData.warmupEmailsSentThisMonth >=
          usageData.maxWarmupEmailsSentThisMonth
        );
    }
  };

  return { isUsageLimitReached };
};
